<template>
  <div class="modelContent">
    <div class="selectType">
      <span>模型系列</span>
      <div>
        <span
          v-for="(item, index) in seriesList"
          :key="index"
          :class="{ active: selectedSeries === item.value }"
          @click="selectedSeries = item.value"
        >
          {{ item.label }}
        </span>
      </div>
    </div>
    <div class="selectType">
      <span>模型类型</span>
      <div>
        <span
          v-for="(item, index) in typeList"
          :key="index"
          :class="{ active: selectedType === item.value }"
          @click="selectedType = item.value"
        >
          {{ item.label }}
        </span>
      </div>
    </div>
    <div class="content">
      <div class="list" v-for="(item, index) in filteredModelList" :key="index" @click="openDetail(item)">
        <img v-if="item.series === 'DeepSeek'" src="@/assets/img/model_d.png" alt="" />
        <img v-else-if="item.series === 'Qwen'" src="@/assets/img/model_q.png" alt="" />
        <img v-else-if="item.series === 'THUDM'" src="@/assets/img/model_zp.png" alt="" />
        <img v-else src="@/assets/img/model_tx.png" alt="" />
        <div class="title">{{ item.name }}</div>
        <div class="tag">{{ item.type }}</div>
        <div class="install" :class="{ not: item.status === '未安装' }">
          {{ item.status }}
        </div>
        <div class="model-info" v-if="showDetailIndex === index">
          <div class="info-item">
            <span class="label">规格：</span>
            <span class="value">{{ item.spec }}</span>
          </div>
          <div class="info-item">
            <span class="label">文本处理：</span>
            <span class="value">{{ item.textProcess }}</span>
          </div>
          <div class="info-item">
            <span class="label">介绍：</span>
            <span class="value">{{ item.intro }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="detail" v-if="showDetailModal" @click="showDetailModal = false">
      <div @click.stop>
        <div class="header">
          <div class="title">{{ selectedModel.name }}</div>
          <img class="close" src="@/assets/icons/ai_model_gb.png" alt="" @click="showDetailModal = false" />
        </div>
        <div class="tag">
          <div class="list">
            <img src="@/assets/icons/ai_model_dx.png" alt="" />
            <span>规格：</span>
            <span>{{ selectedModel.spec }}</span>
          </div>
          <div class="list">
            <img src="@/assets/icons/ai_model_cl.png" alt="" />
            <span>文本处理：</span>
            <span>{{ selectedModel.textProcess }}</span>
          </div>
          <div class="list">
            <img src="@/assets/icons/ai_model_zy.png" alt="" />
            <span>模型类型：</span>
            <span>{{ selectedModel.type }}</span>
          </div>
          <div class="list">
            <img src="@/assets/icons/ai_model.png" alt="" />
            <span>模型系列：</span>
            <span>{{ selectedModel.series }}</span>
          </div>
        </div>
        <div class="intro">
          <div class="title">应用简介：</div>
          <div>
            {{ selectedModel.intro }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      selectedSeries: 'all',
      selectedType: 'all',
      showDetailIndex: -1,
      showDetailModal: false,
      selectedModel: {},
      seriesList: [
        { label: '全部', value: 'all' },
        { label: 'DeepSeek', value: 'DeepSeek' },
        { label: 'Qwen', value: 'Qwen' },
        { label: '智谱', value: 'THUDM' },
        { label: '腾讯混元', value: 'tencent' },
        // { label: '其他', value: 'BAAI' }
      ],
      typeList: [
        { label: '全部', value: 'all' },
        { label: '文本生成', value: '文本生成' },
        // { label: 'Rerank模型', value: 'Rerank模型' },
        { label: '视频生成', value: '视频生成' }
      ],
      modelList: [
        {
          name: 'DeepSeek-R1-Distill-Qwen-7B',
          type: '文本生成',
          status: '未安装',
          spec: '7B',
          textProcess: '32K',
          series: 'DeepSeek',
          intro:
            'DeepSeek-R1-Distill-Qwen-7B 是基于 Qwen2.5-Math-7B 通过知识蒸馏得到的模型。该模型使用 DeepSeek-R1 生成的 80 万个精选样本进行微调，展现出优秀的推理能力。在多个基准测试中表现出色，其中在 MATH-500 上达到了 92.8% 的准确率，在 AIME 2024 上达到了 55.5% 的通过率，在 CodeForces 上获得了 1189 的评分，作为 7B 规模的模型展示了较强的数学和编程能力。'
        },
        {
          name: 'DeepSeek-R1-Distill-Qwen-1.5B',
          type: '文本生成',
          status: '未安装',
          spec: '1.5B',
          textProcess: '32K',
          series: 'DeepSeek',
          intro:
            'DeepSeek-R1-Distill-Qwen-1.5B 是基于 Qwen2.5-Math-1.5B 通过知识蒸馏得到的模型。该模型使用 DeepSeek-R1 生成的 80 万个精选样本进行微调，在多个基准测试中展现了不错的性能。作为一个轻量级模型，在 MATH-500 上达到了 83.9% 的准确率，在 AIME 2024 上达到了 28.9% 的通过率，在 CodeForces 上获得了 954 的评分，显示出超出其参数规模的推理能力。'
        },
        {
          name: 'DeepSeek-R1-Distill-Qwen-14B',
          type: '文本生成',
          status: '未安装',
          spec: '14B',
          textProcess: '32K',
          series: 'DeepSeek',
          intro:
            'DeepSeek-R1-Distill-Qwen-14B 是基于 Qwen2.5-14B 通过知识蒸馏得到的模型。该模型使用 DeepSeek-R1 生成的 80 万个精选样本进行微调，展现出优秀的推理能力。在多个基准测试中表现出色，其中在 MATH-500 上达到了 93.9% 的准确率，在 AIME 2024 上达到了 69.7% 的通过率，在 CodeForces 上获得了 1481 的评分，显示出在数学和编程领域的强大实力。'
        },
        {
          name: 'DeepSeek-R1-Distill-Qwen-32B',
          type: '文本生成',
          status: '已安装',
          spec: '32B',
          textProcess: '32K',
          series: 'DeepSeek',
          intro:
            'DeepSeek-R1-Distill-Qwen-32B 是基于 Qwen2.5-32B 通过知识蒸馏得到的模型。该模型使用 DeepSeek-R1 生成的 80 万个精选样本进行微调，在数学、编程和推理等多个领域展现出卓越的性能。在 AIME 2024、MATH-500、GPQA Diamond 等多个基准测试中都取得了优异成绩，其中在 MATH-500 上达到了 94.3% 的准确率，展现了强大的数学推理能力。'
        },
        {
          name: 'Qwen2.5-7B-Instruct',
          type: '文本生成',
          status: '未安装',
          spec: '7B',
          textProcess: '32K',
          series: 'Qwen',
          intro:
            'Qwen2.5-7B-Instruct 是阿里云发布的最新大语言模型系列之一。该 7B 模型在编码和数学等领域具有显著改进的能力。该模型还提供了多语言支持，覆盖超过 29 种语言，包括中文、英文等。模型在指令跟随、理解结构化数据以及生成结构化输出（尤其是 JSON）方面都有显著提升。'
        },
        {
          name: 'Qwen2.5-Coder-7B-Instruct',
          type: '文本生成',
          status: '未安装',
          spec: '7B',
          textProcess: '32K',
          series: 'Qwen',
          intro:
            'Qwen2.5-Coder-7B-Instruct 是阿里云发布的代码特定大语言模型系列的最新版本。该模型在 Qwen2.5 的基础上，通过 5.5 万亿个 tokens 的训练，显著提升了代码生成、推理和修复能力。它不仅增强了编码能力，还保持了数学和通用能力的优势。模型为代码智能体等实际应用提供了更全面的基础。'
        },
        {
          name: 'Qwen2-7B-Instruct',
          type: '文本生成',
          status: '未安装',
          spec: '7B',
          textProcess: '32K',
          series: 'Qwen',
          intro:
            'Qwen2-7B-Instruct 是 Qwen2 系列中的指令微调大语言模型，参数规模为 7B。该模型基于 Transformer 架构，采用了 SwiGLU 激活函数、注意力 QKV 偏置和组查询注意力等技术。它能够处理大规模输入。该模型在语言理解、生成、多语言能力、编码、数学和推理等多个基准测试中表现出色，超越了大多数开源模型，并在某些任务上展现了与专有模型相当的竞争力。Qwen2-7B-Instruct 在多项评测中均优于 Qwen1.5-7B-Chat，显示出显著的性能提升'
        },
        {
          name: 'Qwen2-1.5B-Instruct',
          type: '文本生成',
          status: '未安装',
          spec: '1.5B',
          textProcess: '32K',
          series: 'Qwen',
          intro:
            'Qwen2-1.5B-Instruct 是 Qwen2 系列中的指令微调大语言模型，参数规模为 1.5B。该模型基于 Transformer 架构，采用了 SwiGLU 激活函数、注意力 QKV 偏置和组查询注意力等技术。它在语言理解、生成、多语言能力、编码、数学和推理等多个基准测试中表现出色，超越了大多数开源模型。与 Qwen1.5-1.8B-Chat 相比，Qwen2-1.5B-Instruct 在 MMLU、HumanEval、GSM8K、C-Eval 和 IFEval 等测试中均显示出显著的性能提升。'
        },
        {
          name: 'glm-4-9b-chat',
          type: '文本生成',
          status: '未安装',
          spec: '9B',
          textProcess: '128K',
          series: 'THUDM',
          intro:
            'GLM-4-9B-Chat 是智谱 AI 推出的 GLM-4 系列预训练模型中的开源版本。该模型在语义、数学、推理、代码和知识等多个方面表现出色。除了支持多轮对话外，GLM-4-9B-Chat 还具备网页浏览、代码执行、自定义工具调用（Function Call）和长文本推理等高级功能。模型支持 26 种语言，包括中文、英文、日语、韩语和德语等。在多项基准测试中，GLM-4-9B-Chat 展现了优秀的性能，如 AlignBench-v2、MT-Bench、MMLU 和 C-Eval 等。该模型支持最大 128K 的上下文长度，适用于学术研究和商业应用。'
        },
        // {
        //   name: 'bge-reranker-v2-m3',
        //   type: 'Rerank模型',
        //   status: '未安装',
        //   spec: '568M',
        //   textProcess: '8K',
        //   series: 'BAAI',
        //   intro:
        //     'bge-reranker-v2-m3 是一个轻量级的多语言重排序模型。它基于 bge-m3 模型开发，具有强大的多语言能力，易于部署，并且推理速度快。该模型采用查询和文档作为输入，直接输出相似度分数，而不是嵌入向量。它适用于多语言场景，特别是在中文和英文处理方面表现出色。'
        // },
        {
          name: 'HunyuanVideo-HD',
          type: '视频生成',
          status: '未安装',
          spec: '13B',
          textProcess: '',
          series: 'tencent',
          intro:
            'HunyuanVideo 是腾讯推出的开源视频生成基础模型，拥有超过 130 亿参数，是目前最大的开源视频生成模型。该模型采用统一的图像和视频生成架构，集成了数据整理、图像-视频联合模型训练和高效基础设施等关键技术。模型使用多模态大语言模型作为文本编码器，通过 3D VAE 进行空间-时间压缩，并提供提示词重写功能。根据专业人工评估结果，HunyuanVideo 在文本对齐、运动质量和视觉质量等方面的表现优于现有最先进的模型。'
        }
      ]
    }
  },
  computed: {
    filteredModelList() {
      return this.modelList.filter(model => {
        const seriesMatch = this.selectedSeries === 'all' || model.series === this.selectedSeries
        const typeMatch = this.selectedType === 'all' || model.type === this.selectedType
        return seriesMatch && typeMatch
      })
    }
  },
  methods: {
    openDetail(model) {
      this.selectedModel = model
      this.showDetailModal = true
    },
    closeDetail() {
      this.showDetailModal = false
    },
    // 可以保留这个方法，但不再使用
    toggleDetail(index) {
      if (this.showDetailIndex === index) {
        this.showDetailIndex = -1
      } else {
        this.showDetailIndex = index
      }
    }
  }
}
</script>

<style scoped lang="less">
.modelContent {
  padding: 30px;
  .selectType {
    display: flex;
    align-items: center;
    margin-bottom: 24px;
    > span {
      font-weight: 400;
      font-size: 14px;
      color: #596777;
      padding-right: 39px;
    }
    > div {
      display: flex;
      font-weight: 400;
      span {
        font-size: 14px;
        color: #999999;
        margin-right: 39px;
        position: relative;
        cursor: pointer;
      }
      span.active {
        font-weight: 800;
        color: #000000;
        &::after {
          content: '';
          width: 23px;
          height: 4px;
          background: #ff6d00;
          border-radius: 3px;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          bottom: -10px;
        }
      }
    }
  }
  .content {
    display: flex;
    flex-wrap: wrap;
    .list {
      width: 18%;
      margin-right: 2.5%;
      margin-bottom: 20px;
      position: relative;
      background-color: #fff;
      border-radius: 8px;
      padding-bottom: 12px;
      // box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
      transition: all 0.3s;
      cursor: pointer;
      &:hover {
        box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
        transform: translateY(-2px);
      }

      img {
        width: 100%;
        border-top-left-radius: 8px;
        border-top-right-radius: 8px;
      }
      .title {
        height: 40px;
        line-height: 40px;
        font-weight: 700;
        font-size: 14px;
        color: #000000;
        padding: 0 15px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .tag {
        padding: 0 8px;
        height: 26px;
        border-radius: 4px;
        border: 1px solid rgba(77, 103, 137, 0.27);
        font-weight: 400;
        font-size: 11px;
        color: #4d6789;
        line-height: 24px;
        width: fit-content;
        margin-left: 15px;
      }
      .install {
        width: 55px;
        height: 25px;
        background: rgba(255, 255, 255, 0.8);
        border-radius: 6px;
        text-align: center;
        line-height: 25px;
        position: absolute;
        top: 7px;
        right: 8px;
        font-weight: 400;
        font-size: 12px;
        color: #999999;
      }
      .not{
        color: #000000;
      }
      .model-info {
        padding: 10px 15px;
        margin-top: 10px;
        background-color: #f9f9f9;
        border-radius: 0 0 8px 8px;

        .info-item {
          margin-bottom: 8px;

          .label {
            font-weight: 700;
            color: #333;
          }

          .value {
            color: #666;
            font-size: 12px;
            line-height: 1.5;
          }
        }
      }
      .detail-btn {
        text-align: center;
        margin-top: 10px;
        color: #1890ff;
        font-size: 12px;
        cursor: pointer;
      }
    }
    .list:nth-child(5n) {
      margin-right: 0;
    }
  }
  .detail {
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    > div {
      width: 773px;
      padding: 31px 42px;
      background-image: url('~@/assets/img/model_detail.png');
      background-size: 100% 100%;
      .header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 29px;
        .title {
          font-weight: 600;
          font-size: 18px;
          color: #000000;
          line-height: 29px;
          position: relative;
          &::after {
            content: '';
            width: 3px;
            height: 14px;
            background: #4d6bfe;
            position: absolute;
            bottom: 50%;
            transform: translateY(50%);
            left: -11px;
          }
        }
        .close {
          width: 14px;
          height: 14px;
          cursor: pointer;
        }
      }
      .tag {
        display: flex;
        align-items: center;
        margin-bottom: 29px;
        justify-content: space-between;
        .list {
          display: flex;
          align-items: center;
          position: relative;
          &::before {
            content: '';
            width: 1px;
            height: 19px;
            background: #e7e7e7;
            position: relative;
            left: -14px;
          }
          img {
            width: 21px;
            height: 21px;
            margin-right: 12px;
          }
          span {
            font-weight: 700;
            font-size: 14px;
            color: #000000;
          }
          span:last-child {
            font-weight: 400;
          }
        }
        .list:first-child {
          &::before {
            display: none;
          }
        }
      }
      .intro {
        display: flex;
        .title {
          width: 70px;
          height: 21px;
          font-weight: 700;
          font-size: 14px;
          color: #000000;
        }
        > div:nth-child(2) {
          flex: 1;
          font-weight: 400;
          font-size: 14px;
          color: #000000;
        }
      }
    }
  }
}
</style>
